import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { CoreApiConfiguration } from '../coreApiConfiguration';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
@Injectable()
export class PharmacySetupService extends ServiceBase {

    private actionUrl: string;
    private headers: Headers;
    private _url: string;
    private _getActiveUrl: string;

    constructor(private _http: HttpClient, private _configuration: CoreApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this._url = this.actionUrl + _configuration.pharmacySetup.url;
        this._getActiveUrl = this.actionUrl + _configuration.pharmacySetup.getActive;
    }

    get = (): Observable<any[]> => {
        return this._http.get<any>(this._url);
    }

    getActive = (): Observable<any> => {
        return this._http.get<any>(this._getActiveUrl);
    }

    insert = (data: any): Observable<any> => {
        return this._http.post<any>(this._url, data);
    }

    update = (data: any): Observable<any> => {
        return this._http.put<any>(`${this._url}?id=${data.id}`, data);
    }
}
